<template>
  <div>
    <v-dialog v-model="kisokCreation" persistent width="500px">
      <v-card class="overflow-hidden">
        <v-toolbar dense class="gradient-bg elevation-0 white--text">
          <v-toolbar-title>Create Kiosk</v-toolbar-title><v-spacer />
          <v-icon @click="close_dialog()" class="white--text mr-n3"
            >mdi-close</v-icon
          >
        </v-toolbar>
        <v-card-text>
          <div class="mt-5">
            <v-form ref="form">
              <v-text-field
                dense
                outlined
                label="Name"
                v-model="nameKisok"
                :rules="[(v) => !!v || 'required']"
              />
              <v-autocomplete
                label="Select Location *"
                v-model="filterlocation"
                :rules="[(v) => !!v || 'required']"
                :items="filterlocations"
                :search-input.sync="searchF"
                hide-no-data
                hide-selected
                hint="Start typing to Search"
                dense
                item-text="location_name"
                item-value="location_id"
                outlined
                return-object
              />
              <div>
                By selecting an option below, you decide who the kiosk scan
                applies to:
              </div>
              <v-radio-group v-model="configuration" row>
                <v-radio label="Employee" value="EMPLOYEE"></v-radio>
                <v-radio label="Visitor" value="VISITOR"></v-radio>
                <v-radio label="Employee and Visitor" value="BOTH"></v-radio>
              </v-radio-group>
              <div v-if="configuration == 'EMPLOYEE'">
                Employees: Scan applies only to employees and consumes 1 credit.
              </div>
              <div v-if="configuration == 'VISITOR'">
                Visitors: Scan applies only to visitors and consumes 2 credits.
              </div>
              <div v-if="configuration == 'BOTH'">
                Employee and Visitor: Scan applies to both employees and
                visitors and consumes 3 credits.
              </div>
            </v-form>
          </div>
        </v-card-text>
        <div class="d-flex justify-end mb-3">
          <v-card-actions class="">
            <v-btn
              color="primary"
              class="white--text"
              :loading="loading"
              @click="delete_freeforms()"
              small
              >Yes</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
        <script>
import { GetLocation } from "@/mixins/GetLocationList.js";
import { API, graphqlOperation } from "aws-amplify";
import { CreateKiosk } from "@/graphql/mutations.js";
export default {
  mixins: [GetLocation],
  components: {},
  props: {
    kisokCreation: Boolean,
  },
  data: () => ({
    configuration: "EMPLOYEE",
    loading: false,
    nameKisok: "",
    filterlocation: "",
    filterlocations: [],
    searchF: null,
  }),
  watch: {
    kisokCreation: {
      async handler() {
        {
          if (this.kisokCreation == true) {
            await this.GetLocation();
            await this.fetch_details();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    fetch_details() {
      this.GetLocationitems.forEach((element) => {
        this.filterlocations.push({
          location_name: element.loc_name,
          location_id: element.loc_id,
        });
      });
    },
    close_dialog() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("clicked", 0);
    },
    async delete_freeforms() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let result = await API.graphql(
            graphqlOperation(CreateKiosk, {
              input: {
                kiosk_type: this.configuration,
                kiosk_name: this.nameKisok,
                organisation_id:
                  this.$store.getters.get_org_details[0].organisation_id,
                location_id: this.filterlocation.location_id,
                location_name: this.filterlocation.location_name,
                action_taken_by: this.$store.getters.get_useremail,
              },
            })
          );
          // console.log(result);
          var response = JSON.parse(result.data.CreateKiosk);
          this.loading = false;
          if (response.Status == "SUCCESS") {
            this.$emit("successMsg", response.Message);
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.loading = false;
          } else {
            this.$emit("errorMsg", response.Message);
            this.loading = false;
          }
        } catch (error) {
          console.log(error);
          this.$emit("errorMsg", error.errors[0].message);
          this.loading = false;
        }
      }
    },
  },
};
</script>